import { LogoImage } from 'img';
import styled from 'styled-components';

import { HEADER_HEIGHT } from '../../constants';

export const StyledLogo = styled(LogoImage)`
    width: 96px;
`;

export const TenantLogo = styled.img`
    height: ${ ({ theme }) => theme.size.size_25 };
    width: auto;
`;

export const UserLogoContainer = styled.div`
    align-items: center;
    display: flex;
    margin-right: auto;
`;

export const TopHat = styled.div`
    align-items: center;
    background-color: ${ props => props.theme.primaryBackground };
    box-shadow: ${ props => props.theme.shadow.shadow_1 };
    display: flex;
    height: ${ HEADER_HEIGHT }px;
    left: 0;
    padding: 0 ${ ({ theme }) => theme.size.size_40 };
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isTablet } {
        padding: 0 ${ ({ theme }) => theme.size.size_30 };
    }

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
        padding: 0 ${ ({ theme }) => theme.size.size_20 };
    }
`;
